import { Outlet } from 'react-router-dom';

export default function SubMethods() {
    return (
        <Outlet />
    )
}
